export type CompareVersionValidationResult = {
  type: CompareVersionValidationError;
  text: string;
  severity: "warning" | "error";
};

export enum CompareVersionValidationError {
  SameVersions,
  NotLatestVersionAsReference,
  DifferentProjects,
}
